import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  CONTACT_VK,
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_PHONE,
  POLICY_DATE,
  SITES_LABEL,
} from '../legal/operator';

export default function TermsPage() {
  return (
    <LegalDoc title="Пользовательское соглашение">
      <p>
        Настоящий документ — договор о доступе к сайту {SITES_LABEL} (далее — Сайт).
        Редакция: {POLICY_DATE}
      </p>

      <h2>1. Кто принимает</h2>
      <p>
        Соглашение принимает человек, который регистрируется: ученик, родитель или
        репетитор. Акцепт — отдельная отметка «Принимаю пользовательское соглашение».
      </p>
      <p>
        Если ученику нет 14 лет, соглашение для его аккаунта принимает родитель,
        когда отправляет ребёнку ссылку на регистрацию.
      </p>
      <p>
        Занятия с репетитором этим документом не оформляются. Их оформляет{' '}
        <Link to={OFERTA_PATH}>договор-оферта</Link>, его принимает родитель.
      </p>

      <h2>2. Что даётся сейчас</h2>
      <p>
        После регистрации открывается личный кабинет: задания, редактор, журнал,
        переписка на Сайте в тех разделах, которые доступны роли. Плата за сам
        доступ сейчас не берётся.
      </p>

      <h2>3. Платный доступ</h2>
      <p>
        Платный доступ ученика или репетитора к Сайту включается с момента оплаты
        тарифа, опубликованного на Сайте. Пока тариф на Сайте не опубликован, этот
        раздел не применяется и плата за доступ не берётся.
      </p>
      <p>
        Оплата доступа идёт через платёжный сервис на Сайте. Чек направляется на
        email, указанный при оплате. Порядок возврата за неиспользованный
        оплаченный период публикуется вместе с тарифом.
      </p>

      <h2>4. Правила учётки</h2>
      <p>
        Один человек — один аккаунт. Несколько аккаунтов ради счётчика задач или
        времени не заводятся. Сведения в профиле человек указывает свои.
      </p>
      <p>
        Материалы Сайта используются для своей учёбы или своей работы на Сайте.
        Выкладывать чужие решения от своего имени и мешать работе Сайта нельзя.
      </p>

      <h2>5. Персональные данные</h2>
      <p>
        Порядок обработки описан в{' '}
        <Link to="/privacy">политике обработки персональных данных</Link>.
        Согласие на учебные сведения и анкету даётся{' '}
        <Link to="/consent">отдельным документом</Link>. Настоящее соглашение
        само по себе согласием на персональные данные не является.
      </p>

      <h2>6. Срок</h2>
      <p>
        Соглашение действует с отметки при регистрации, пока аккаунт не удалён и
        человек не отказался от него письмом на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>.
        Отказ от соглашения прекращает доступ к кабинету. Оплаченные занятия и их
        возврат регулирует договор-оферта на занятия.
      </p>

      <h2>7. Реквизиты</h2>
      <ul>
        <li>Наименование: {OPERATOR_NAME}</li>
        <li>ОГРНИП: {OPERATOR_OGRNIP}</li>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>
          email:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>телефон: {OPERATOR_PHONE}</li>
        <li>
          ВКонтакте:{' '}
          <a href={CONTACT_VK} target="_blank" rel="noopener noreferrer">
            vk.com/boris_vlasenko
          </a>
        </li>
      </ul>
    </LegalDoc>
  );
}
